import React from "react";
import img2 from "../../../../../../assets/images/AISummit/aicopilot3.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";
import { TbServer } from "react-icons/tb";
import { TbChartCircles } from "react-icons/tb";

const FiveYears = () => {
    return (
        <section className="row mx-0 align-items-center justify-content-center my-5 py-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-6">
                        <h6 className="fs-14">Experience</h6>
                        <h1>Five years proven</h1>
                        <p>Join student leaders, faculty, and tech enthusiasts in hosting inspiring events that transform how your campus learns and grows. Datacode brings five years of community expertise directly to your institution.</p>
                    </div>
                    <div className="col-12 col-md-6">
                        <p>We’ve hosted over 100 tech events across online sessions, expert classes, master classes, beginner series, workshops, in-person meetings, hackathons, and community meetups. Datacode knows how to build momentum and keep students engaged.</p>
                        <CustomButton>Discover</CustomButton>
                        <CustomButton className="bg-light text-dark border ml-4">Partner</CustomButton>
                    </div>
                </div>
                <div className="row mx-0 d-flex align-items-center justify-content-center my-5 py-5">
                    <div className="col-12 col-md-6 text-center">
                        <TbServer size={32} />
                        <h3 className="fs-32">Bring Datacode to campus</h3>
                        <p>Host a workshop or expert class at your college. We handle the rest.</p>
                        <CustomButton>Host</CustomButton>
                        <CustomButton className="bg-light text-dark border ml-4">Contact</CustomButton>
                    </div>
                    <div className="col-12 col-md-6 text-center">
                        <TbChartCircles size={32} />
                        <h4 className="fs-32">Learn something real</h4>
                        <p>Sign up for the next master class or hackathon happening near you.</p>
                        <CustomButton>Join</CustomButton>
                        <CustomButton className="bg-light text-dark border ml-4">Events</CustomButton>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FiveYears;
